import { Controller } from "@hotwired/stimulus";

// Hides an element and remembers dismissal in sessionStorage
export default class extends Controller {
  static values = { key: String };

  connect() {
    if (sessionStorage.getItem(this._storageKey())) {
      this.element.remove();
    }
  }

  dismiss() {
    sessionStorage.setItem(this._storageKey(), "1");
    this.element.remove();
  }

  // Private

  _storageKey() {
    return `dismissed:${this.keyValue}`;
  }
}
